import React, { useState, useRef, useEffect } from "react";
import {
  MenuItem,
  CircularProgress,
  IconButton,
  Menu,
  Dialog,
  Grid,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import dayjs, { Dayjs } from "dayjs";
import sendCreditAxios from "../../../utils/sendCreditAxiosService";
import Calendar from "../../../components/calendar/Calender";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const TransactionDetails = () => {
  const [summaryMobile, setSummaryMobile] = useState<any>([]);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | null>(
    dayjs().add(-7, "days")
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | null>(dayjs());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [circle, setCircle] = useState<Boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedStartDate && selectedEndDate) {
      const startDateParam = selectedStartDate.format("YYYY-MM-DD");
      const endDateParam = selectedEndDate.add(1, "days").format("YYYY-MM-DD");
      setSummaryMobile(null);
      setCircle(true);
      GettransactionDetails(startDateParam || "", endDateParam || "");
    }
  }, [selectedStartDate, selectedEndDate]);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const columnDefs: ColDef[] = [
    {
      field: "cartCreationDate",
      headerName: "Creation Date",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "orderCheckoutDate",
      headerName: "Checkout Date",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "categoryName",
      headerName: "Category Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "subCategoryName",
      headerName: "Subcategory Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "productName",
      headerName: "Product Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "operatorName",
      headerName: "Operator Name",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "transactionID",
      headerName: "Transaction ID ",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "userEmail",
      headerName: "Email ",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "purchaseInventoryStatus",
      headerName: "Inventory Status",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "failureReason",
      headerName: "Failure Reason",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "vendorFinalStatus",
      headerName: "Final Status",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "paymentMethod",
      headerName: "Payment Method",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "refund",
      headerName: "Refund",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "message",
      headerName: "Message",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "orderAmount",
      headerName: "Order Amount",
      filter: true,
      sortable: true,
    },

    {
      field: "paymentResposne",
      headerName: "PaymentResposne",
      filter: true,
      sortable: true,
      resizable: true,
    },
  ];

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleCalendar = () => {
    setCalendarOpen(!calendarOpen);
    handleMenuClose();
  };

  const handleStartDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedStartDate(date);
    }
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedEndDate(date);
    }
  };

  const GettransactionDetails = async (startDate: string, endDate: string) => {
    toast.dismiss();
    await sendCreditAxios
      .post(`/CRMTransaction/GetTransactionsAsync`, {
        FromDate: startDate,
        toDate: endDate,
      })
      .then((response: any) => {
        const responseData = response.data?.payload;

        if (responseData?.length > 0) {
          setSummaryMobile(responseData); // Update state with the payload data
          setCircle(false);
        } else {
          toast.info("No record Found");
          setCircle(false);
        }
      })
      .catch((error: any) => {
        console.error(error);
        setCircle(false);
      });
  };

  const onRowClicked = (event: { data: any }) => {
    const rowData = event.data;
    setSelectedRowData(rowData);
    setOpen(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div>
        <h2 className="heading">Transaction Details</h2>
        {selectedEndDate &&
          selectedStartDate &&
          Math.floor(selectedEndDate.diff(selectedStartDate, "day", true)) ===
            7 && <span className="small-text">Last 7 Days</span>}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <button
            className="small-btn"
            style={{ visibility: summaryMobile ? "visible" : "hidden" }}
            onClick={() => {
              if (summaryMobile) {
                exportGridDataAsCSV();
              }
            }}
          >
            Export as CSV
          </button>
        </div>
        <IconButton
          onClick={(e: any) => {
            handleMenuClick(e);
          }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={toggleCalendar}></MenuItem>
          {selectedStartDate && selectedEndDate && (
            <Calendar
              selectedStartDate={selectedStartDate}
              selectedEndDate={selectedEndDate}
              onStartDateChange={handleStartDateChange}
              onEndDateChange={handleEndDateChange}
            />
          )}
        </Menu>
      </div>

      {circle && (
        <div className="dummy-conatiner">
          <CircularProgress size={40} />
        </div>
      )}
      {summaryMobile && (
        <div
          className="ag-theme-alpine hideTransactionDetail"
          style={{ width: "100%", height: "425px", overflowY: "auto" }}
        >
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={50}
            pagination={true}
            rowData={summaryMobile}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onRowClicked={onRowClicked}
            getRowStyle={(params: any) => {
              if (params.data.vendorFinalStatus === "DECLINED") {
                return { backgroundColor: "#f3c2c2" };
              }
              return undefined;
            }}
          ></AgGridReact>
        </div>
      )}

      {selectedRowData != null && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="dialogBox"
        >
          <h2
            style={{
              fontWeight: "bold",
              margin: "10px 0",
              paddingLeft: "10px",
            }}
          >
            Details
          </h2>
          <Grid
            container
            spacing={2}
            style={{
              margin: "3px 0 20px 0",
              width: "100%",
              padding: "0px 10px 0px 10px",
            }}
          >
            <Grid item xs={12} style={{ padding: "0" }}>
              <Grid container>
                <Grid item xs={5}>
                  <p className="tableHeader">Checkout Date</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">
                    {selectedRowData.orderCheckoutDate}
                  </p>
                </Grid>

                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Sub Category Name
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.subCategoryName}
                  </p>
                </Grid>

                <Grid item xs={5}>
                  <p className="tableHeader">Product Name</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">{selectedRowData.productName}</p>
                </Grid>

                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    operator Name
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.operatorName}
                  </p>
                </Grid>

                <Grid item xs={5}>
                  <p className="tableHeader">Transaction ID </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">{selectedRowData.transactionID}</p>
                </Grid>
                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Email
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.userEmail}
                  </p>
                </Grid>
                <Grid item xs={5}>
                  <p className="tableHeader">Final Status</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">
                    {selectedRowData.vendorFinalStatus}
                  </p>
                </Grid>
                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Payment Method
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.paymentMethod}
                  </p>
                </Grid>
                <Grid item xs={5}>
                  <p className="tableHeader">Refund</p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p className="tableData">{selectedRowData.refund}</p>
                </Grid>
                <Grid item xs={5}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Order Amount
                  </p>
                </Grid>
                <Grid item xs={7} md={7}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.orderAmount}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </motion.div>
  );
};

export default TransactionDetails;
